import { IconProps } from '../../types/IconProps';

export const Info = ({ variant, className }: IconProps) => {
  let fill;
  switch (variant) {
    case 'light':
      fill = '#fff';
      break;
    case 'dark':
      fill = '#0B223E';
      break;
    default:
      fill = 'currentColor';
  }
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      className={`${className || ''}`}>
      <path
        fill={fill}
        d='M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2Zm0 18.462A8.461 8.461 0 1 1 20.462 12 8.47 8.47 0 0 1 12 20.462Zm1.539-3.847a.77.77 0 0 1-.77.77 1.538 1.538 0 0 1-1.538-1.539V12a.77.77 0 1 1 0-1.539A1.538 1.538 0 0 1 12.769 12v3.846a.77.77 0 0 1 .77.77ZM10.46 7.77a1.154 1.154 0 1 1 2.308 0 1.154 1.154 0 0 1-2.308 0Z'
      />
    </svg>
  );
};
